import { getCookie, setCookie } from '@common/utils/cookie';
import { toast } from '@common/ui/general/Toast';

export const getData = (keyName) => {
  try {
    if (typeof localStorage !== 'undefined') {
      return JSON.parse(localStorage.getItem(keyName));
    } else {
      return JSON.parse(getCookie(keyName));
    }
  } catch (error) {
    return null;
  }
};

export const setData = (key, value) => {
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      setCookie(key, JSON.stringify(value));
    }
  } catch (error) {
    toast.show({
      message: error,
      type: 'error',
      duration: 5000,
    });
  }
};
